const messages = {
  dashboard: {
    title: "Dashboard van de salesvertegenwoordiger",
    description:
      "Welkom op uw dashboard. Hier kunt u actuele cijfers en deelnemende bedrijven van uw klantenbestand bekijken.",
    overview: {
      title: "Overzicht van deelnemende klanten",
      description:
        'Bedrijven die zich hebben geregistreerd bij BRIDGESTONE <span class="text-danger">PLUS</span> en die wij via het klantnummer aan u kunnen toewijzen.',
      month: "Nieuw deze maand",
      year: "Nieuw dit jaar",
      all: "Puntentotaal",
    },
    credits: {
      title: "Puntencredits",
      description:
        "Punten toegekend aan deelnemende bedrijven op basis van de ingediende verkoopcijfers.",
      month: "Vorige maand",
      year: "Huidig jaar",
      prev_year: "Puntentotaal",
      allDealers: "Alle dealerpunten",
      allPoints: "Alle punten",
      prev_month: "Vorige maand",
    },
    details: {
      title: "Deelnemende klanten in detail",
      description:
        'Hieronder vindt u een lijst met bedrijven die zich met een Bridgestone-klantnummer hebben geregistreerd bij BRIDGESTONE <span class="text-danger">PLUS</span> en aan u als manager zijn toegewezen. Gebruik de sorteerfuncties of de zoekbalk om de weergavevolgorde te wijzigen. Let op: Als u op het puntensaldo klikt, wordt u doorgeleid naar het gedetailleerde rekeningoverzicht.',
    },
    lastImport:
      'Laatste import van verkoopcijfers: <br/> <span class="text-danger">{date}</span>',
    kickback: {
      description:
        "Deelnemende bedrijven ontvangen tegoeden in de vorm van een bonus op basis van de ingediende verkoopcijfers.",
    },
    tyres: {
      title: "Banden",
      description: "Banden gekocht door deelnemers aan het bonusprogramma",
    },
    short:
      "Welkom in uw dashboard. Hier kunt u actuele cijfers en deelnemende bedrijven uit uw klantenbestand bekijken.",
    headers: {
      city: "Stad",
      company: "Bedrijf",
      current_points: "punten tot nu toe",
      customer_number: "klantnummer",
      details: "details",
      last_login: "Laatste login",
      name: "naam",
      postal_code: "Postcode",
      street: "straat",
      email: "E-mail",
    },
    reload: "Vernieuwen",
    exports: {
      title: "Geëxporteerde Excels",
      downloadExcel: "Excel downloaden",
      running: "Bezig",
      head: {
        name: "Naam",
        status: "Status",
      },
    },
  },
};
export default {
  messages,
};
